export default "__VITE_PUBLIC_ASSET__03886475__"